// extracted by mini-css-extract-plugin
export default {"googleAccountContainer":"googleAccountContainer__ijRsPHA8Ug8QnGkle4RAa","headerButton":"headerButton__3B2nGMpoZx1MJsFDdeJkiq"};